module.exports = __webpack_public_path__ + "ecs.icon.83b41.svg";